import { useCallback } from 'react';

import { useTracking } from '@change-corgi/core/react/tracking';

import {
	useStarterDashboardCommentsPageData,
	useStarterDashboardCommentsPagePaginatedData,
} from '../../../../pageContext';
import type { Comment } from '../../../../pageContext';

type Result = ModelHookResult<
	{
		hasNextPage: boolean;
		comments: readonly Comment[];
		nextPageLoading: boolean;
		hasSignedPetition: boolean;
	},
	{ loadMore: () => void }
>;

export function usePageBody(): Result {
	const {
		data: { petition, hasSignedPetition },
	} = useStarterDashboardCommentsPageData();
	const {
		data: { hasNextPage, items, nextPageLoading },
		actions: { loadMore },
	} = useStarterDashboardCommentsPagePaginatedData();
	const track = useTracking();

	return {
		data: {
			comments: items,
			hasNextPage,
			nextPageLoading,
			hasSignedPetition,
		},
		actions: {
			loadMore: useCallback(() => {
				loadMore();
				void track('comment_feed_scroll', {
					comment_feed_type: 'recent',
					commentable_id: petition.id,
					commentable_type: 'Event',
					comment_count: items.length,
				});
			}, [items.length, loadMore, petition.id, track]),
		},
	};
}
